export default {
  'editorial-staff': 'Nuestro equipo editorial',
  'published-on': 'Publicado el',
  'read-articles': 'Leer sus artículos',
  'about-author': 'Sobre el autor',
}
